<template>
    <div>
        <pagamento
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            v-show="mostrarPagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        >
            <template slot="comprometimentosBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="toAssociarComprometimentos()"
                        v-if="mostrarBtnAssociarComprometimentos"
                        ><i class="fa fa-plus"></i> Associar Serviços</b-button
                    >
                </b-button-group>
            </template>
            <template slot="mensagem">
                <b-alert show variant="danger" class="mt-4" v-if="mostrarAviso">
                    <b-row>
                        <b-col sm="12">
                            <div class="d-flex justify-content-start">
                                <i class="fa fa-exclamation-circle fa-2x"></i>
                                <h4 class="ml-2">
                                    Registro de pagamento ainda não foi enviado
                                    para análise.
                                </h4>
                            </div>
                        </b-col>
                    </b-row>
                </b-alert>
            </template>
        </pagamento>
        <router-view
            v-if="pagamento"
            :pagamento="pagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamento from './componentes/Pagamento'
import { pagamentoStatus } from './componentes/PagamentoStatus'

export default {
    data() {
        return {
            pagamento: {}
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.pagamento = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter o pagamento.',
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.obterPagamento()
            this.$store.dispatch('setRecarregar', true)
        },

        toAssociarComprometimentos() {
            this.$router.push({
                name: 'Contratos_Pagamentos_AssociarComprometimentos'
            })
        }
    },

    computed: {
        mostrarBtnAssociarComprometimentos() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('CONT-PAG-04')
            )
        },

        mostrarPagamento() {
            return this.$route.name === 'Contratos_Pagamentos_Detalhar'
        },

        mostrarAviso() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                (this.pagamento.comprometimentos.length > 0 ||
                    this.pagamento.anexos.length > 0)
            )
        }
    },

    components: {
        Pagamento: Pagamento
    },

    created() {
        this.obterPagamento()
    }
}
</script>
